<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo32bg.svg" />

    <div class="hover-animation-c appearAnimationA">
      <p id="tag01" class="textBase">
        la principal función del canto de los sapos es atraer
      </p>
      <p id="tag02" class="textBase">a las hembras.</p>
    </div>

    <p class="textBase appearAnimationB" id="text02">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >los sapos cantan principalmente para ahuyentar<br />
      a las hembras.
      <input type="radio" name="sapos" />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >los sapos cantan principalmente para llamar<br />
      a las hembras.
      <input type="radio" name="sapos" />
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 108px;
  top: 460px;
}
label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#tag01 {
  position: absolute;
  width: 873px;
  height: 50px;
  left: 55px;
  top: 68px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
  text-transform: uppercase;
}
#tag02 {
  position: absolute;
  width: 259px;
  height: 50px;
  left: 55px;
  top: 132px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
  text-transform: uppercase;
}
#text02 {
  position: absolute;
  left: 72px;
  top: 192px;
  font-size: 30px;
  line-height: 41px;
  color: #00a5a5;
}
#toggle01 {
  position: absolute;
  left: 65px;
  top: 278px;
}
#toggle02 {
  position: absolute;
  left: 65px;
  top: 393px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 143b.mp4"],
    };
  },
};
</script>